import {
    apiRequest,
    kriteriaSkpTunkinList,
    kriteriaSkpTunkinActive,
    kriteriaSkpTunkinInactive
} from "../../../../../services/adapters/kepegawaian/kriteriaSkpTunkinService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", kriteriaSkpTunkinList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", kriteriaSkpTunkinInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", kriteriaSkpTunkinActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository